<ng-template #titleTpl>
  <intelishs-page-header
    title="Nueva Solicitud de Vacaciones"
    [subtitle]="saldo()?.empleadoNombre ?? ''"
  />
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (saldo(); as s) {
      <div class="modal-detail">
        <div class="detalle-seccion">
          <intelishs-section-header title="Periodo" />
          <nz-range-picker
            style="width: 100%"
            [ngModel]="dateRange()"
            (ngModelChange)="onRangeChange($event)"
            [nzDisabledDate]="disabledDate"
            [nzDateRender]="renderCelda"
            nzFormat="yyyy-MM-dd"
            (keydown.enter)="commitRangeOnEnter(onRangeChange, $event)"
          />
          <ng-template #renderCelda let-current>
            <div
              class="ant-picker-cell-inner"
              [class.date-fuera-politica]="esDentroDeDosSemanas(current)"
            >
              {{ current.getDate() }}
            </div>
          </ng-template>
          <div class="form-hint">
            <nz-icon nzType="clock-circle" />
            La política establece al menos 2 semanas de anticipación (desde
            {{ fechaMinimaSolicitud | date: 'dd/MM/yyyy' }}).
          </div>
          @if (fechaInicioInvalida()) {
            <div class="form-warning">
              <nz-icon nzType="warning" />
              Este rango de fechas no cumple la política de 2 semanas de anticipación. Requiere
              aprobación por Director y RH.
            </div>
          }
        </div>
        <!-- Días hábiles, festivos excluidos y reparto FIFO en un solo bloque:
             las tres cosas responden a la misma pregunta —"qué me va a costar
             este rango"— y separadas obligaban a rearmarlas mentalmente. -->
        @if (diasSolicitados() > 0) {
          <div class="resumen">
            <div class="resumen-total">
              <span class="resumen-total-lbl">Días hábiles</span>
              <span class="resumen-total-val">{{ diasSolicitados() }}</span>
            </div>

            @if (festivosEnRango().length > 0) {
              <p class="resumen-nota">
                No cuentan {{ textoFestivos() }}:
                {{ festivosEnRangoNombres() }}
              </p>
            }

            @if (distribucionFIFO(); as fifo) {
              <div class="resumen-desglose">
                <span class="resumen-desglose-lbl">Se descuentan de</span>
                @if (fifo.delAnterior > 0) {
                  <div class="resumen-row">
                    <span>Ciclo anterior <em>(vence primero)</em></span>
                    <span class="resumen-row-val"
                      >{{ fifo.delAnterior | number: '1.1-1' }} días</span
                    >
                  </div>
                }
                @if (fifo.delActual > 0) {
                  <div class="resumen-row">
                    <span>Ciclo actual</span>
                    <span class="resumen-row-val">{{ fifo.delActual | number: '1.1-1' }} días</span>
                  </div>
                }
                @if (fifo.delSiguiente > 0) {
                  <div class="resumen-row">
                    <span>Ciclo siguiente <em>(inicia en tu aniversario)</em></span>
                    <span class="resumen-row-val"
                      >{{ fifo.delSiguiente | number: '1.1-1' }} días</span
                    >
                  </div>
                }
                @if (fifo.excedente > 0) {
                  <div class="resumen-row resumen-row--negativo">
                    <span>Sin saldo para esas fechas</span>
                    <span class="resumen-row-val">{{ fifo.excedente | number: '1.1-1' }} días</span>
                  </div>
                }
              </div>
              @if (fifo.excedente > 0) {
                <p class="resumen-nota resumen-nota--negativo">
                  Esta solicitud excede tu saldo: no puedes registrarla. Se cuentan tus solicitudes
                  pendientes y autorizadas, y los días que habrás generado a la fecha de cada día.
                  Acorta el periodo o elige fechas más adelante.
                </p>
              }
            }
          </div>
        }

        <!-- Sin `nz-divider` entre secciones: el section-header ya trae su
             propia línea, y las dos juntas parten el modal en franjas. -->
        <div class="detalle-seccion">
          <intelishs-section-header title="Comentarios" />
          <textarea
            nz-input
            rows="2"
            placeholder="Motivo o comentarios..."
            [ngModel]="comentarios()"
            (ngModelChange)="comentarios.set($event)"
          ></textarea>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cancelar</button>
    <button
      nz-button
      class="btn-add"
      [nzLoading]="submitting()"
      [disabled]="diasSolicitados() === 0 || excedeSaldo()"
      (click)="submit()"
    >
      Enviar Solicitud
    </button>
  </ng-template>
</nz-modal>
